import { Link } from 'react-router-dom';

const SpecialOffer = ({ specialData, allSpecials, multiSpecial = false, menuSlug, type = null }) => {
    // Handle multiple specials
    if (multiSpecial && allSpecials && Array.isArray(allSpecials) && allSpecials.length > 0) {
        return (
            <div className="headless-multiple-specials">
                {allSpecials.map((special, index) => (
                    <Link
                        key={`special-${special.id}-${index}`}
                        to={
                            special.id
                                ? `/shop/${menuSlug}/special/${special.id}/`
                                : menuSlug
                                ? `/shop/${menuSlug}/specials/`
                                : '#'
                        }
                        reloadDocument
                    >
                        <div className='headless-product-special'>
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                height='1em'
                                viewBox='0 0 512 512'
                            >
                                <path d='M204.1 32c12.7 0 24.9 5.1 33.9 14.1L410.7 218.7c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0L14.1 270.1c-9-9-14.1-21.2-14.1-33.9V80C0 53.5 21.5 32 48 32H204.1zM36.7 247.4L209.4 420.1c12.5 12.5 32.8 12.5 45.3 0L388.1 286.6c12.5-12.5 12.5-32.8 0-45.3L215.4 68.7c-3-3-7.1-4.7-11.3-4.7H48c-8.8 0-16 7.2-16 16V236.1c0 4.2 1.7 8.3 4.7 11.3zM308.4 36.9c6.1-6.4 16.2-6.6 22.6-.5l141.3 135c52.8 50.4 52.8 134.7 0 185.1l-124.6 119c-6.4 6.1-16.5 5.9-22.6-.5s-5.9-16.5 .5-22.6l124.6-119c39.6-37.8 39.6-101 0-138.8L308.9 59.6c-6.4-6.1-6.6-16.2-.5-22.6zM104 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48z' />
                            </svg>
                            {type && type === 'discount' ? (
                                <span>Discount applied</span>
                            ) : (
                                <div className='product-card-special'>
                                    <span className='product-card-special-tag'>
                                        Special offer
                                    </span>
                                    {special.name && (
                                        <span className='product-card-speical-name'>
                                            {' '}
                                            - {special.name}
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                    </Link>
                ))}
            </div>
        );
    }

    // Handle single special (backward compatibility)
    if (!specialData) {
        return null;
    }

    return (
        <SingleSpecialOffer
            specialData={specialData}
            menuSlug={menuSlug}
            type={type}
        />
    );
};

// Extract single special rendering logic to avoid duplication
const SingleSpecialOffer = ({ specialData, menuSlug, type = null }) => {
    if (!specialData) {
        return null;
    }

    return (
        <Link
            to={
                specialData.id
                    ? `/shop/${menuSlug}/special/${specialData.id}/`
                    : menuSlug
                    ? `/shop/${menuSlug}/specials/`
                    : '#'
            }
            reloadDocument
        >
            <div className='headless-product-special'>
                <svg
                    xmlns='http://www.w3.org/2000/svg'
                    height='1em'
                    viewBox='0 0 512 512'
                >
                    <path d='M204.1 32c12.7 0 24.9 5.1 33.9 14.1L410.7 218.7c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0L14.1 270.1c-9-9-14.1-21.2-14.1-33.9V80C0 53.5 21.5 32 48 32H204.1zM36.7 247.4L209.4 420.1c12.5 12.5 32.8 12.5 45.3 0L388.1 286.6c12.5-12.5 12.5-32.8 0-45.3L215.4 68.7c-3-3-7.1-4.7-11.3-4.7H48c-8.8 0-16 7.2-16 16V236.1c0 4.2 1.7 8.3 4.7 11.3zM308.4 36.9c6.1-6.4 16.2-6.6 22.6-.5l141.3 135c52.8 50.4 52.8 134.7 0 185.1l-124.6 119c-6.4 6.1-16.5 5.9-22.6-.5s-5.9-16.5 .5-22.6l124.6-119c39.6-37.8 39.6-101 0-138.8L308.9 59.6c-6.4-6.1-6.6-16.2-.5-22.6zM104 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48z' />
                </svg>
                {type && type === 'discount' ? (
                    <span>Discount applied</span>
                ) : (
                    <div className='product-card-special'>
                        <span className='product-card-special-tag'>
                            Special offer
                        </span>
                        {specialData.name && ( // Use specialData directly
                            <span className='product-card-speical-name'>
                                {' '}
                                - {specialData.name}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </Link>
    );
};

export default SpecialOffer;
